import React from "react";
import { Box, Typography } from "@mui/material";

const InstructionStep = React.memo(({ number, title, children, icon }) => (
  <Box sx={{ 
    mb: 2,
    display: 'flex',
    gap: 2,
    alignItems: 'flex-start'
  }}>
    <Box
      sx={{
        width: 28,
        height: 28,
        minWidth: 28,
        borderRadius: '50%',
        backgroundColor: '#e0f7fa',
        color: '#219297',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: '0.85rem',
        flexShrink: 0,
      }}
    >
      {icon || number}
    </Box>
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography 
        variant="subtitle2"
        fontWeight="600" 
        sx={{ 
          color: '#333',
          mb: 0.5,
          fontSize: '0.9rem'
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          color: '#666',
          fontSize: '0.85rem',
          lineHeight: 1.5,
        }}
      >
        {children}
      </Typography>
    </Box>
  </Box>
));

export default InstructionStep;